/**
 * webストレージマネージャクラス
 */
export default {
  length,
  getPointInfo,
  getPoint1Info,
  getPoint2Info,
  getPoint3Info,
  getPoint4Info,
  getPoint5Info,
  getDefaultInfo,
  getCustomInfo,
  setPoint1Info,
  setPoint2Info,
  setPoint3Info,
  setPoint4Info,
  setPoint5Info,
  setDefaultInfo,
  setCustomInfo,
  setNotification,
  getNotification,
  rewriteDefaultInfo,
  rewriteViewGroup,
};

/**
 * 登録地点数を返却
 */
function length() {
  return 5;
}

/**
 * 登録地点情報をjsonで返却
 * @param {*} num 登録地点番号（1～3）
 */
function getPointInfo(num) {
  let key = "point_" + num;
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem(key));
  }
}

/**
 * 登録地点１情報をjsonで返却
 */
function getPoint1Info() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("point_1"));
  }
}

/**
 * 登録地点１情報を登録
 * @param {*} json 登録地点１情報
 */
function setPoint1Info(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("point_1", JSON.stringify(json));
    }
  }
}

/**
 * 登録地点２情報をjsonで返却
 */
function getPoint2Info() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("point_2"));
  }
}

/**
 * 登録地点２情報を登録
 * @param {*} json 登録地点２情報
 */
function setPoint2Info(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("point_2", JSON.stringify(json));
    }
  }
}

/**
 * 登録地点３情報をjsonで返却
 */
function getPoint3Info() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("point_3"));
  }
}

/**
 * 登録地点３情報を登録
 * @param {*} json 登録地点３情報
 */
function setPoint3Info(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("point_3", JSON.stringify(json));
    }
  }
}

/**
 * 登録地点４情報をjsonで返却
 */
function getPoint4Info() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("point_4"));
  }
}

/**
 * 登録地点４情報を登録
 * @param {*} json 登録地点４情報
 */
function setPoint4Info(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("point_4", JSON.stringify(json));
    }
  }
}

/**
 * 登録地点５情報をjsonで返却
 */
function getPoint5Info() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("point_5"));
  }
}

/**
 * 登録地点５情報を登録
 * @param {*} json 登録地点５情報
 */
function setPoint5Info(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("point_5", JSON.stringify(json));
    }
  }
}

/**
 * 初期表示設定情報をjsonで返却
 */
function getDefaultInfo() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("default"));
  }
}

/**
 * 初期表示設定情報を登録
 * @param {*} json 初期表示設定情報
 */
function setDefaultInfo(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("default", JSON.stringify(json));
    }
  }
}

/**
 * カスタマイズ設定情報をjsonで返却
 */
function getCustomInfo() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("custom"));
  }
}

/**
 * カスタマイズ設定情報を登録
 * @param {*} json カスタマイズ設定情報
 */
function setCustomInfo(json) {
  if (window.localStorage) {
    if (typeof json !== "undefined") {
      window.localStorage.setItem("custom", JSON.stringify(json));
    }
  }
}

/**
 * 通知設定を登録
 * @param {*} accessDate アクセス日時
 */
function setNotification(notification) {
  if (window.localStorage) {
    if (typeof notification !== "undefined") {
      window.localStorage.setItem("notification", JSON.stringify(notification));
    }
  }
}

/**
 * 通知設定を返却
 */
function getNotification() {
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("notification"));
  }
}

/**
 * 初期表示設定情報の書き換え(表示ｸﾞﾙｰﾌﾟ設定以外)
 */
function rewriteDefaultInfo(idx, val) {
  let info = Object.assign({}, getDefaultInfo());
  if (typeof val !== "undefined") {
    info[idx] = val;
  }
  setDefaultInfo(info);
}

/**
 * 初期表示設定情報の書き換え(表示ｸﾞﾙｰﾌﾟ設定)
 */
function rewriteViewGroup(num, length) {
  let info = Object.assign({}, getDefaultInfo());
  for (let i = 1; i <= length; i++) {
    let idx = "disp" + i;
    // 選択された項目のみtrueにする
    if (i <= 5) {
      info[idx] = i === num + 1 ? true : false;
    } else {
      info.dispCustom = i === num + 1 ? true : false;
    }
  }
  setDefaultInfo(info);
}
